import React, { useEffect, useState } from 'react'

import { ScrollAnimation } from 'shared/components'
import classes from './Map.module.scss'
import { useWindowSize } from 'shared/hooks'
import { YMaps, Map as Maps, Placemark } from '@pbe/react-yandex-maps'

const pointer: [number, number] = [55.7669341, 37.6188852]

export const Map = (): JSX.Element => {
  const { width } = useWindowSize()
  const [maxWidth, setMaxWidth] = useState(getMaxWidth())

  function getMaxWidth(): string {
    return `${document.documentElement.clientWidth}px`
  }

  useEffect(() => {
    setMaxWidth(getMaxWidth())
  }, [width])

  return (
    <div className={`${classes.container} container`}>
      <ScrollAnimation
        animatedProp="width"
        styles={{ maxWidth, minWidth: '100% !important' }}
        classes={`${classes.wrapper}`}
        speed={1.1}
        removeBorderRadius
      >
        <YMaps
          query={{
            apikey: 'd1f6ffaa-d006-4ec5-aef3-adbeb88f189c',
            ns: 'use-load-option',
            load: 'Map,Placemark,geoObject.addon.balloon,control.ZoomControl',
          }}
        >
          <Maps
            width="100%"
            height="100%"
            defaultState={{
              center: pointer,
              zoom: 18,
              controls: ['zoomControl'],
            }}
            options={{
              autoFitToViewport: 'always',
              maxAnimationZoomDifference: 5,
              copyrightLogoVisible: false,
            }}
          >
            <Placemark
              geometry={pointer}
              properties={{ balloonContentBody: 'Офис компании KION' }}
            />
          </Maps>
        </YMaps>
      </ScrollAnimation>
    </div>
  )
}
